/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { Select } from '@atoms';
import { NARROW_COL } from '@constants';
import { useSegments } from '@api/hooks';

import Form from '../Form';

const SegmentsField = ({ queryVariables, disabled, ...props }) => {
  /* { enabled: !disabled } this looks really funny but it needs to prevent fetching segments when there is no audience selected */
  const { segments, isFetching } = useSegments(queryVariables, { enabled: !disabled });

  return (
    <Form.Item wrapperCol={NARROW_COL} {...props}>
      <Select.Entities
        disabled={disabled}
        loading={isFetching}
        placeholder="- Choose a segment -"
        entities={segments}
        formatLabel={({ name }) => name}
      />
    </Form.Item>
  );
};

export default SegmentsField;
